import Slider from "react-slick";
import React from 'react'
import BreadCrumb from '../../components/BreadCrumb'

export default function AboutContent({ data }) {
  return (
    <>
      <section className="about-top-content">
        <img src="/assets/images/about-top-bg.webp" alt="Innovation" className="top-bg img-responsive" />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-9">
              <div className="content-sec">
                <BreadCrumb data={data?.breadcrumb} />
                <h1 className="heading">The Supershine Story</h1>
                <p>Supershine’s journey spans over 35+ Years of innovation, and family-driven values. From humble beginnings to becoming a trusted name in commercial laundry, we deliver high-quality, reliable solutions that businesses can depend on worldwide, backed by expertise, performance, service excellence, and long-term customer relationships, while continuously evolving through advanced technology and customer-focused innovation across global laundry industries.</p>

                <div className="border-section">
                  <img src="/assets/images/about-border-line.webp" alt="Border" className="img-responsive" />

                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="about-main-image">
          <div className="about-image">
            <img src="/assets/images/about-slider-img1.webp" alt="Slider" className="img-responsive" />
          </div>
          <div className="about-image">
            <img src="/assets/images/about-slider-img2.webp" alt="Slider" className="img-responsive" />
          </div>
          <div className="about-image">
            <img src="/assets/images/about-slider-img3.webp" alt="Slider" className="img-responsive" />
          </div>
          <div className="about-image">
            <img src="/assets/images/about-slider-img4.webp" alt="Slider" className="img-responsive" />
          </div>
          <div className="about-image">
            <img src="/assets/images/about-slider-img5.webp" alt="Slider" className="img-responsive" />
          </div>
        </div>
      </section>

    </>
  )
}
